import { ProductCardHelper } from '@services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardHelper.ts';
import { find, go, last, sumBy } from 'fxjs/es';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { PRODUCT_BADGE_TYPE } from '../Constant/item.js';

/**
 * @remarks
 * NESS 상품 목록/상세에서는 `NessBadgeListView`를 사용해주세요.
 *
 * @param props
 * @param props.goods_type_id {GoodsTypeId}
 * @param props.stock {ProductStockDto}
 * @param props.limitedMeta {LimitedMetaDto|undefined}
 * @param props.is_force_out_of_stock {boolean}
 * @param props.quantity {number}
 * @param props.order_count
 * @param props.sell_end_at {Date|null}
 * @param props.need_all
 * @param is_studio
 *
 */
export const setBadge = (props, is_studio) => {
  if (UtilS.isNessApp() && !is_studio) {
    return [];
  }

  // TODO: @coconut 마이그레이션 후 제거
  if (!props.stock) {
    return [];
  }

  if (!props.goods_type_id) {
    throw new Error('goods_type_id is required');
  }

  // badge 설정
  const badges = [];

  // Sold out
  if (props.stock.isOutOfStock || ProductCardHelper.isEndedSale({ sell_end_at: props.sell_end_at })) {
    badges.push({
      type: PRODUCT_BADGE_TYPE.sold_out,
      name: ET('product_detail::badges::sold_out'),
    });
  }

  // Limited
  if (
    props.limitedMeta?.isLimited ||
    props.stock.stockStatus === 'LEGACY_LIMITED_OUT_OF_STOCK' ||
    props.stock.stockStatus === 'LEGACY_LIMITED_AVAILABLE'
  ) {
    badges.push({
      type: PRODUCT_BADGE_TYPE.limit,
      name: ET('product_detail::badges::limited'),
    });
  }

  return is_studio || props.need_all
    ? badges
    : find(({ name }) => name != T(`mshop::ProductBadge::한정`), badges) || last(badges);
};

export const setSimpleBadge = ({
  sell_start_at,
  sell_end_at,
  quantity,
  order_count,
  ordered_at,
  is_sptg,
  spo_item_stocks,
  is_quantity_public,
}) => {
  if (!quantity && !sell_start_at && !sell_end_at && !ordered_at && !is_sptg && !spo_item_stocks?.length)
    return null;

  const is_no_spo_item_stock =
    spo_item_stocks?.length &&
    go(
      spo_item_stocks,
      sumBy(({ quantity }) => quantity),
    ) === 0;
  const start_at = new Date(sell_start_at);
  const end_at = new Date(sell_end_at);
  const now = Date.now();
  /* 매진 */
  const badges = [];

  if ((quantity > 0 && quantity <= order_count) || (sell_start_at && end_at <= now) || is_no_spo_item_stock) {
    badges.push({ type: 'sold_out' });
  } else {
    if (sell_start_at && sell_end_at) {
      const is_coming = now < start_at;
      const { day, hour, minute } = UtilS.differenceTimeInUnits(
        ['day', 'hour', 'minute', 'second'],
        is_coming ? start_at : end_at,
        now,
        true,
      );
      if (is_coming) {
        return { type: 'coming', day, hour, minute };
      } else if (end_at > now) {
        badges.push({ type: 'remaining', day, hour, minute });
      }
    }

    /* 한정 수량 */
    if (quantity > 0 && quantity > order_count) {
      const qty = quantity - order_count;
      badges.push(is_quantity_public ? { type: 'qty', qty } : { type: 'qty_hide' });
    }

    if (is_sptg) {
      badges.push({
        type: 'nft',
        name: 'NFT',
      });
    }
  }
  /* 설정기간 이전 */

  /* 가격할인 */

  /* 실시간 판매 */
  return badges;
};
